/**
 * Defines available explanation modes and labels.
 * Used across spec page for mode toggling.
 *
 * defaultMode sets initial view.
 */

export const modeLabels = {
  friends: 'Friends Mode',
  colleague: 'Colleague Mode'
};

export const availableModes = ['friends', 'colleague'];

export const defaultMode = 'friends';